"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPhoneErrorSelector = hasPhoneErrorSelector;
exports.isAutosubmitEnabled = isAutosubmitEnabled;
exports.isPhoneAuthFormSubmitting = isPhoneAuthFormSubmitting;
exports.isPhoneInvalidSelector = isPhoneInvalidSelector;
exports.phoneErrorSelector = phoneErrorSelector;
exports.phoneSelector = phoneSelector;
var _phoneAuth = require("../../../../types/phoneAuth");
var _requestStatus = require("../../../../types/requestStatus");
var _validation = require("../../../../utils/validation");
function phoneSelector(state) {
  return state.phoneAuth.phone;
}
function isAutosubmitEnabled(state) {
  return state.phoneAuth.isAutosubmitEnabled;
}
function isPhoneAuthFormSubmitting(state) {
  const {
    sendValidationCode,
    checkPhone
  } = state.phoneAuth;
  return sendValidationCode.status === _requestStatus.ERequestStatus.Loading || checkPhone.status === _phoneAuth.ECheckPhoneStatus.Loading;
}
function hasPhoneErrorSelector(state) {
  const {
    sendValidationCode,
    checkPhone
  } = state.phoneAuth;
  const isSendValidationCodeError = sendValidationCode.status === _requestStatus.ERequestStatus.Failed && !!sendValidationCode.error;
  const isCheckPhoneError = checkPhone.status === _phoneAuth.ECheckPhoneStatus.Failed && !!checkPhone.error;
  return isSendValidationCodeError || isCheckPhoneError;
}
function phoneErrorSelector(state) {
  if (hasPhoneErrorSelector(state)) {
    return state.phoneAuth.sendValidationCode.error || state.phoneAuth.checkPhone.error;
  }
  return;
}
function isPhoneInvalidSelector(state) {
  const {
    phone
  } = state.phoneAuth;
  return !(0, _validation.isValidPhone)(phone);
}